<template>
    <div class="channel-lineup-feature" :class="{loading: loading}">
        <form @submit.prevent="submit" accept-charset="UTF-8" novalidate="novalidate">
            <div class="form-group text-right">
                <dropdown menu-right>
                    <btn class="dropdown-toggle" type="primary">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                    </btn>

                    <template slot="dropdown">
                        <li>
                            <a role="button" @click="openModal" :disabled="loading">
                                Import Excel File
                            </a>
                        </li>
                    </template>
                </dropdown>
            </div>

            <div class="form-group has-feedback" :class="{'has-error': errors.has('Feature[title]')}">
                <label for="feature-title">Title</label>
                <input id="feature-title"
                       v-validate="'required'"
                       v-model="feature.title"
                       required="required"
                       name="Feature[title]"
                       class="form-control"
                       aria-required="true">

                <span v-show="errors.has('Feature[title]')" class="help-block">
                    {{ errors.first('Feature[title]') }}
                </span>
            </div>

            <label>Channels</label>

            <div class="form-group has-feedback" v-for="(datum, index) in feature.data">
                <div class="input-group">
                    <input class="form-control" required v-model="datum.channel"
                           :name="'Feature[data][' + ( index + 1 ) + ']'">

                    <span class="input-group-btn">
                        <button class="btn btn-warning" type="button" @click="removeRow(index)">Remove</button>
                    </span>
                </div>
            </div>

            <br>

            <div class="row">
                <div class="col-xs-6 form-group">
                    <button class="btn btn-sm btn-info" @click="sort" type="button">Sort</button>
                </div>

                <div class="col-xs-6 form-group text-right">
                    <a v-on:click="addRow" class="btn btn-sm btn-primary">
                        Add Channel
                    </a>
                </div>
            </div>


            <hr>

            <div class="row">
                <div class="col-xs-6">
                    <button type="button" class="btn btn-warning btn-sm" :disabled="loading"
                            v-if="feature.id && feature.deleted_at"
                            @click="restoreFeature">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="btn btn-danger btn-sm" :disabled="loading" v-else-if="feature.id"
                            @click="deleteFeature">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </div>

                <div class="col-xs-6">
                    <button type="submit" class="btn btn-success btn-lg btn-block" :disabled="loading">
                        Save
                    </button>
                </div>
            </div>
        </form>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               :clickToClose="false"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <form @submit.prevent="processFile" method="POST"
                      accept-charset="UTF-8"
                      class="margin-md-top"
                      data-vv-scope="workbook"
                      novalidate="novalidate">
                    <fieldset>
                        <legend>Import File</legend>
                    </fieldset>

                    <div class="form-group has-feedback"
                         :class="{'has-error': errors.has('workbook.file')}">
                        <input v-validate="'required'"
                               aria-required="true"
                               required
                               id="file"
                               name="file"
                               type="file"
                               class="form-control dropable"
                               @change="onFileChange">

                        <span v-show="errors.has('workbook.file')" class="help-block">
                            {{ errors.first('workbook.file') }}
                        </span>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 col-ld-4 form-group">
                            <a class="btn btn-link" :disabled="loading" @click="closeModal">
                                Close
                            </a>
                        </div>

                        <div class="col-sm-6 col-ld-4 form-group pull-right">
                            <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                Load Data
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    var XLSX = require( 'xlsx' );

    export default {
        props: {
            featureId: {
                type: String,
                default(){
                    return null;
                }
            },

            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },
        },

        data(){
            return {
                feature: {
                    data: [
                        {
                            channel: null
                        }
                    ]
                },

                file: null,
                loading: false,
            };
        },

        created: function(){
            this.init();
        },

        computed: {
            importForm(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );

                if( this.feature.id ){
                    form.setAttribute( 'action', '/features/' + this.feature.id );
                    hiddenField.setAttribute( 'value', 'PUT' );
                }
                else {
                    form.setAttribute( 'action', '/features' );
                    hiddenField.setAttribute( 'value', 'POST' );
                }

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                _.forIn( this.feature, ( value, key ) => {
                    if( _.isArray( value ) ){
                        _.each( value, ( arrayValue, arrayKey ) => {
                            let field = document.createElement( 'input' );
                            field.setAttribute( 'type', 'hidden' );
                            field.setAttribute( 'name', 'Feature[' + key + '][' + arrayKey + ']' );
                            field.setAttribute( 'value', arrayValue.channel );
                            form.appendChild( field );
                        } );
                    }
                    else {
                        let field = document.createElement( 'input' );
                        field.setAttribute( 'type', 'hidden' );
                        field.setAttribute( 'name', 'Feature[' + key + ']' );
                        field.setAttribute( 'value', value );
                        form.appendChild( field );
                    }
                } );

                return form;
            },
        },

        methods: {
            init(){
                this.loading = true;
                var promise = Promise.resolve( {} );

                if( this.featureId ){
                    this.feature.id = this.featureId;

                    promise.then( () => {
                        return this.loadFeature();
                    } );
                }

                return promise
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            loadFeature(){
                var url = '/api/features/' + this.feature.id;

                return axios.get( url )
                    .then( ( response ) => {
                        var feature = response.data.Feature;

                        feature.data = _.map( feature.data, ( datum ) => {
                            return {
                                channel: datum
                            };
                        } );

                        this.$set( this, 'feature', feature );
                    } );
            },

            addRow(){
                this.feature.data.push( {
                    channel: null
                } );
            },

            removeRow( index ){
                this.feature.data.splice( index, 1 );
            },

            submit(){
                const form = this.importForm;

                return this.$validator.validateAll()
                    .then( ( valid ) => {

                        if( valid ){
                            this.loading = true;

                            document.body.appendChild( form );
                            form.submit();
                        }
                    } );
            },

            deleteFeature(){
                this.loading = true;

                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/features/' + this.feature.id );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'DELETE' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                document.body.appendChild( form );
                form.submit();
            },

            restoreFeature(){
                this.loading = true;

                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/features/' + this.feature.id + '/restore' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'PUT' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                document.body.appendChild( form );
                form.submit();
            },

            processFile(){
                return this.$validator.validateAll( 'workbook' )
                    .then( ( valid ) => {
                        if( valid ){
                            this.loadWorkbook();
                            this.closeModal();
                        }
                    } );
            },

            loadWorkbook(){
                var reader = new FileReader();

                reader.onload = ( e ) => {
                    var data = e.target.result;

                    this.parseWorkbook( XLSX.read( data, { type: 'array' } ) );
                };

                reader.readAsArrayBuffer( this.file );
            },

            parseWorkbook( workbook ){
                var sheetName = _.head( workbook.SheetNames );
                var sheet = workbook.Sheets[ sheetName ];

                // Note: this will index all row values by the first row of the spreadsheet
                var parsedSheet = XLSX.utils.sheet_to_json( sheet );

                this.feature.data = _.reduce( parsedSheet, ( carry, row, rowIndex ) => {
                    carry[ rowIndex ] = {
                        channel: _.head( _.valuesIn( row ) )
                    };

                    return carry;
                }, [] );
            },

            sort(){
                this.feature.data = _.sortBy( this.feature.data, function( datum ){
                    return _.toUpper( datum.channel );
                } );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },

            onFileChange( e ){
                this.file = e.target.files[ 0 ];
            },
        }
    }
</script>